{
    "performance": {
        "compilation": {
            "incrementalRebuilds": {
                "type": "boolean",
                "default": true
            }
        },
        "physics": {
            "usePhysicsWorld": {
                "type": "boolean",
                "default": true
            },
            "pixelsPerMeter": {
                "type": "number",
                "default": 100
            },
            "gravityX": {
                "type": "number",
                "default": 0
            },
            "gravityY": {
                "type": "number",
                "default": 9.8
            },
            "engine": {
                "type": "select",
                "options": [
                    "Planck JS"
                ],
                "default": "Planck JS"
            }
        }
    },
    "debugging": {
        "code": {
            "generateJsMap": {
                "type": "boolean",
                "default": false
            }
        }
    },
    "project": {
        "engine": {
            "updateFlintTypes": {
                "type": "button",
                "buttonId": "updateFlintTypes",
                "label": "Update Flint Types"
            }
        }
    }
}
